import { ButtonType, CrudFormConfig, CrudViewFormItemType, FormLayout } from '@rappider/rappider-components/utils';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AI_FUNCTION_FORM_CONFIG: CrudFormConfig = {
  validators: [
    // {
    //   type: {
    //     'pattern': 'KEBAB_CASE_REGEX'
    //   },
    //   'errorKey': 'pattern',
    //   'errorMessage': 'ERRORS.PATTERN_MESSAGES.PROJECT_MODEL_NAME_ERROR'
    // }
  ],
  items: [
    {
      'type': CrudViewFormItemType.TextBox,
      'title': 'Name',
      'fieldName': 'name',
      'columnWidth': 100,
      'placeholder': 'Name',
      'description': 'Name of the function, kebab case, e.g. : generate-scope-of-work',
      'showRequiredSign': true,
      'index': 0
    },
    {
      'type': CrudViewFormItemType.TextArea,
      'title': 'Description',
      'fieldName': 'description',
      'columnWidth': 100,
      'placeholder': 'Description',
      'index': 1
    },
    {
      'type': CrudViewFormItemType.TextArea,
      'title': 'System Prompt',
      'fieldName': 'systemPrompt',
      'columnWidth': 100,
      'placeholder': 'System Prompt',
      'settings': '',
      'description': 'You are an AI assistant responsible for ...',
      'index': 2,
      'showRequiredSign': true
    },
    {
      'type': CrudViewFormItemType.TextArea,
      'title': 'Function Prompt',
      'fieldName': 'functionPrompt',
      'columnWidth': 100,
      'placeholder': 'Function Prompt',
      'description': 'Here is my project description: The Task Management ...',
      'settings': '',
      'showRequiredSign': true,
      'index': 3
    },
    {
      'type': CrudViewFormItemType.MonacoCodeEditor,
      'title': 'Response Sample as Json',
      'fieldName': 'responseJsonSample',
      'columnWidth': 100,
      'placeholder': 'Response Sample as Json',
      'index': 4
    },
    {
      'type': CrudViewFormItemType.TextBox,
      'title': 'Post Workflow Step Function Id',
      'fieldName': 'postWorkflowStepFunctionId',
      'columnWidth': 100,
      'placeholder': 'uuid',
      'settings': '',
      'description': 'Optional Post Workflow Step Function Id',
      'index': 5
    }
  ],
  itemSettings: {
    'labelComponentSize': {
      'xs': 4,
      'sm': 0,
      'md': 0,
      'lg': 0,
      'xl': 0,
      'xxl': 0
    },
    inputComponentSize: {
      'xs': 20,
      'sm': 0,
      'md': 0,
      'lg': 0,
      'xl': 0,
      'xxl': 0
    }
  },
  'formLayout': FormLayout.Vertical,
  'submitButton': {
    'text': 'Save',
    'visible': true,
    'size': 'default',
    'type': ButtonType.Primary,
  }
};

